import { toast } from 'sonner';

/**
 * Wraps a mutation call with success/error toasts.
 *
 * Usage:
 *   mutateWithToast(interrupt, agent.id, { success: 'Agent interrupted', error: 'Failed to interrupt' });
 */
export function mutateWithToast<TVariables>(
  mutation: {
    mutate: (
      vars: TVariables,
      opts?: { onSuccess?: () => void; onError?: (err: Error) => void },
    ) => void;
  },
  variables: TVariables,
  messages: { success: string; error: string },
) {
  mutation.mutate(variables, {
    onSuccess: () => toast.success(messages.success),
    onError: (err) => toast.error(messages.error, { description: err.message }),
  });
}
